import React from 'react';
import TickboxActive from './svg/TickboxActive';
import TickboxInactive from './svg/TickboxInactive';
import TickboxSporadic from './svg/TickboxSporadic';
import PropTypes from 'prop-types';

const Tickbox = ({
    value,
    size = 13,
    disabled = false,
    style,
    onClick,
    ...props
}) => {
    style = {
        cursor: disabled ? 'default' : 'pointer',
        ...style
    };

    const handleClick = (event) => {
        if (!disabled && onClick) {
            onClick(event);
        }
    };

    const tickboxProps = {
        onClick: handleClick,
        ...props
    };

    return value === 'sporadic' ? (
        <TickboxSporadic size={size} {...tickboxProps} style={style} />
    ) : value ? (
        <TickboxActive size={size} {...tickboxProps} style={style} />
    ) : (
        <TickboxInactive size={size} {...tickboxProps} style={style} />
    );
};

Tickbox.defaultProps = {
    size: 13,
    disabled: false
};

Tickbox.propTypes = {
    value: PropTypes.any,
    size: PropTypes.number,
    disabled: PropTypes.any,
    style: PropTypes.object,
    onClick: PropTypes.func
};

export default Tickbox;
